<template>
        <div id="app" class="container">
        
	<b-navbar toggleable type="dark" variant="primary">
            <b-navbar-brand href="/" style="margin-left: 10px;">DIFRACO</b-navbar-brand>
            <h6 v-if="(user.email === 'difraco.admon@gmail.com' || user.email === 'ajtamayoh@gmail.com')" style="color: #fff;" class="ms-auto">Admin: {{user.email}}</h6>
            <h6 v-else-if="user != ''" style="color: #fff;" class="ms-auto">Usuario: {{user.email}}</h6>
            &nbsp;&nbsp;
            <b-navbar-toggle target="navbar-toggle-collapse" style="margin-right: 10px;">
            <template #default="{ expanded }">
                <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
                <b-icon v-else icon="chevron-bar-down"></b-icon>
            </template>
            </b-navbar-toggle>

            <b-collapse id="navbar-toggle-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item href="/login" style="margin-left: 10px;"><router-link to="login"><b-button v-if="user === ''" variant="outline-light">Iniciar sesión</b-button></router-link></b-nav-item>
                <b-nav-item href="/presentacion" style="margin-left: 10px;"><router-link to="presentacion"><b-button v-if="user != ''" variant="outline-light" @click="signOut()">Cerrar sesión</b-button></router-link></b-nav-item>
            </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        
        <div>
            <h1 class="d-flex justify-content-center" style="margin-top: 20px;">
                DIFRACO
            </h1>

            <h3 class="d-flex justify-content-center" style="text-align: justify;">
                Diccionario Fraseológico de Colombia
            </h3>
        </div> 

        <b-nav class="d-flex navbar navbar-expand-sm bg-light navbar-dark" v-if="(user != '' && (user.email != 'difraco.admon@gmail.com' && user.email != 'ajtamayoh@gmail.com'))">
            <ul class="navbar-nav">
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/presentacion">Presentación</router-link>
            </li>
            <li class="nav-item m-1">
                    <b-dropdown variant="outline-secondary" id="dropdown-1" text="Unidades fraseológicas">
                        <b-dropdown-item>    
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                            to="/colocaciones">Colocaciones</router-link></a>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                            to="/formulas">Fórmulas pragmáticas</router-link></a>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                             to="/locuciones">Locuciones</router-link></a>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                             to="/marcadores">Marcadores discursivos</router-link></a>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                             to="/refranes">Refranes</router-link></a>
                        </b-dropdown-item>
                    </b-dropdown>
            </li>
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/metodologia">Metodología</router-link>
            </li>
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/blog">Blog</router-link>
            </li>
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/creditos">Créditos</router-link>
            </li>
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/referencias">Referencias</router-link>
            </li>
            </ul>
        </b-nav>

        <b-nav class="d-flex navbar navbar-expand-sm bg-light navbar-dark" v-if="(user.email === 'difraco.admon@gmail.com' || user.email === 'ajtamayoh@gmail.com')">
            <ul class="navbar-nav">
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/presentacion_admin">Presentación</router-link>
            </li>
            <li class="nav-item m-1">
                    <b-dropdown variant="outline-secondary" id="dropdown-1" text="Unidades fraseológicas">
                        <b-dropdown-item>
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                            to="/colocaciones_admin">Colocaciones</router-link></a>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                            to="/formulas_admin">Fórmulas pragmáticas</router-link></a>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                             to="/locuciones_admin">Locuciones</router-link></a>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                             to="/marcadores_admin">Marcadores discursivos</router-link></a>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <a class="dropdown-item" href="#"><router-link class="text-decoration-none text-dark"
                             to="/refranes_admin">Refranes</router-link></a>
                        </b-dropdown-item>
                    </b-dropdown>
            </li>
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/metodologia_admin">Metodología</router-link>
            </li>
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/blog_admin">Blog</router-link>
            </li>
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/creditos_admin">Créditos</router-link>
            </li>
            <li class="nav-item m-1">
                <router-link class="btn btn-light btn-outline-secondary"
                to="/referencias_admin">Referencias</router-link>
            </li>
            </ul>
        </b-nav>

	<!--
        <div style="margin-top: 20px; max-width: 20rem;" v-if="user != ''">
            <b-card bg-variant="dark" text-variant="white" size="sm">
                <div class="card-body">
                    <h5 class="card-title">Administrador autorizado</h5>
                    <h6 class="card-title">{{user.displayName}}</h6>
                    <p class="card-text">{{user.email}}</p>
                    <small><a href="#" class="btn btn-secondary" @click="signOut()">Salir</a></small>
                </div>
            </b-card>
        </div>
        -->

        <router-view></router-view>

    </div>
</template>

<script>
import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';

export default {
  data() {
    return {
      user: ''
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    });
  },
   methods: {
    signOut() {
        if(!confirm("¿Desea cerrar su sesión en DIFRACO?")){
            return;
        }
	firebase.auth().signOut().then(() => {
        firebase.auth().onAuthStateChanged(() => {
          this.user = '';
          this.$router.push('/presentacion')
        })
      })
    }
  }
};

</script>
